import {Disclosure} from '@github-ui/disclosure'
import type {ChildrenProps} from './sidebar-context'
import styles from './DisclosurePanel.module.css'

export function DisclosurePanel({children}: ChildrenProps) {
  return (
    <div className={styles.Gutter} data-component="Sidebar.DisclosurePanel">
      <Disclosure.Panel className={styles.Contents} data-sidebar-panel>
        {children}
      </Disclosure.Panel>
    </div>
  )
}
